module.exports = __webpack_public_path__ + "img/rotary.8ecfb147.jpg";